<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.9375 11.1428H23.4375M8.19941 3.75V5.6788M20.9375 3.75V5.67856M24.6875 9.05356V22.875C24.6875 24.739 23.1951 26.25 21.3542 26.25H8.02083C6.17988 26.25 4.6875 24.739 4.6875 22.875V9.05356C4.6875 7.1896 6.17988 5.67856 8.02083 5.67856H21.3542C23.1951 5.67856 24.6875 7.1896 24.6875 9.05356Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
